@if (pwaEnabled()) {
    <app-offline-banner />
}
<app-impersonation-banner />
<app-update-banner />
<router-outlet id="mainRoutes" />
<app-error-modal />
<app-tc-acceptance-dialog />
<app-membership-inactive-dialog />
<app-changelog-dialog />
<app-meet-your-team-dialog />
<app-email-review-dialog-host />
<app-approval-toast-host />
<wa-toast id="app-toast-container" [class.toast-hidden]="appState.approvalsViewActive()" [placement]="toastPlacement()" />
<app-env-gate />
